/* eslint-disable class-methods-use-this */
import axios from 'axios';
import { AddressDto, AddressResponse } from '.';

const http = axios.create({
  baseURL: 'https://api.postcodes.io/',
  timeout: 30000,
});

class AddressService {
  public async getAddress(postcode: string): Promise<AddressDto> {
    const result: AddressResponse = await http.get(`postcodes/${postcode}`);
    return result.data.result;
  }

  public async getPostcodes(query: string): Promise<string[]> {
    const result = await http.get(`postcodes/${query}/autocomplete`);
    return result.data.result;
  }
}

export default new AddressService();
